module.exports = __webpack_public_path__ + "img/logout.16760d13.png";